import "./tarifsTextTitle.css";

import TarifsTextCartouche from "./tarifsTextCartouche";

function TarifsTextTitle({
  title = "",
  price = "",
  atelier = false,
  domicile = false,
  time = "",
  minimal = false,
}) {
  const atelierCheck = atelier ? "✅" : "❌";
  const domicileCheck = domicile ? "✅" : "❌";
  const domicileText = minimal ? "" : "À DOMICILE : " + domicileCheck;
  const atelierText = minimal ? "" : "EN ATELIER : " + atelierCheck;
  const p = minimal ? "" : "PRIX : " + price;
  const t = minimal ? "" : "DURÉE : " + time;

  const content = (
    <div className="tarifs-text-title">
      <div className="tarifs-text-title-top">
        <div className="tarifs-text-title-name">{title}</div>
        <div className="tarifs-text-title-site-contenair">
          <div className="tarifs-text-title-site">
            {domicileText}
            <br></br>
            {atelierText}
          </div>
        </div>
      </div>
      <div className="tarifs-text-title-bottom">
        <div className="tarifs-text-title-price">{p}</div>
        <div className="tarifs-text-title-time">{t}</div>
      </div>
    </div>
  );
  return <TarifsTextCartouche bBot="2.5%">{content}</TarifsTextCartouche>;
}

export default TarifsTextTitle;
